/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getTaggings = 'taggings';
export const getCategories = 'fetch-categories';

export const useGetTaggings = (token: string, options: any) => {
    const { search, limit, offset, types, isUntagged = false, sortByName, sortByType } = options;
    return useQuery(
        [getTaggings, token, limit, offset, search, types, isUntagged, sortByName, sortByType],
        () =>
            coreService.tagsApi.getTaggings(token, {
                search,
                limit,
                offset,
                types,
                isUntagged,
                sortByName,
                sortByType
            }),
        {
            enabled: !!token,
            keepPreviousData: true
        }
    );
};

export const useGetCategories = (token: string, includeUntagged: boolean) => {
    return useQuery([getCategories, token], () => coreService.tagsApi.categories(token, includeUntagged), {
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !!token
    });
};
